import React from 'react';
import DriverManagement from './DriverManagement';
import { useTranslation } from 'react-i18next';
import { PAGE_TITLE_ID } from 'reusable/TableScroll';

const Driver: React.FC = () => {
  const { t } = useTranslation('driver');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 id={PAGE_TITLE_ID} className="font-bold text-title">{t('title.title')}</h6>
      <div>
        <DriverManagement />
      </div>
    </section>
  );
};
export default Driver;